"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const config_1 = require("config");
const merchant_portal_components_1 = require("merchant-portal-components");
const utils_1 = require("utils");
const SendReceiptModal = ({ isOpen, setIsOpen, onRequestClose, email, phone, name, createReceipt, transactionId, sendReceipt, receiptUrl, alphaeonAccountNumber, affAutoSend = true, imprintAutoSend = true, isResend = false, receiptData = null, daysUntilAuthExpiration, refetchReceiptsData = lodash_1.noop, optedOutOfSms = false, }) => {
    const [formSubmitted, setFormSubmitted] = (0, react_1.useState)(false);
    const [sentTo, setSentTo] = (0, react_1.useState)(null);
    const history = (0, react_router_dom_1.useHistory)();
    (0, react_1.useEffect)(() => {
        if (receiptUrl &&
            ((receiptUrl.indexOf(config_1.AFF_DOMAIN) >= 0 && affAutoSend) ||
                (receiptUrl.indexOf(config_1.IMPRINT_DOMAIN) >= 0 && imprintAutoSend))) {
            setIsOpen(true);
            setFormSubmitted(true);
            setSentTo(email);
        }
    }, [receiptUrl]);
    const handleCloseLocal = () => {
        if (formSubmitted === true &&
            isOpen === true &&
            history.location.pathname !==
                `${config_1.ACCOUNT_DETAIL_URL}${alphaeonAccountNumber}`) {
            window.location.href = '/merchant';
        }
        else {
            onRequestClose();
        }
    };
    const handleSendReceipt = async () => {
        try {
            const respCreateReceipt = isResend
                ? receiptData
                : await createReceipt(Number(transactionId), 'digital');
            const respSendReceipt = await sendReceipt(Number(transactionId), respCreateReceipt.receiptId, phone, email);
            refetchReceiptsData();
            if (respSendReceipt.emailSent || respSendReceipt.smsSent) {
                setFormSubmitted(true);
                setSentTo(respSendReceipt.sentToEmail || respSendReceipt.sentToSms);
                (0, utils_1.toastSuccess)(`Receipt has been successfully sent.`);
            }
            else {
                handleCloseLocal();
                (0, utils_1.toastError)(`Receipt failed to send.`);
            }
        }
        catch (e) {
            onRequestClose();
            let errMsg = '';
            if (e.response) {
                errMsg = e.response.message;
            }
            else {
                errMsg = `Receipt failed to send.`;
            }
            (0, utils_1.reportError)('flashError', {
                componentName: 'SendReceiptModal',
                funcName: 'handleSendReceipt',
                errType: 'receipt send error',
                errURL: window.location.pathname,
                errMsg: errMsg,
            }, e);
            handleCloseLocal();
            (0, utils_1.toastError)(errMsg);
        }
    };
    const onGoToDashboard = () => {
        window.location.href = '/merchant'; // hard refresh
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(components_1.Modal, { isOpen: isOpen, setIsOpen: setIsOpen, onRequestClose: handleCloseLocal, modalTestId: "send-receipt-modal", closeBtnTestId: "send-receipt-close-button", contentClassName: "alert-modal", children: (0, jsx_runtime_1.jsx)(merchant_portal_components_1.SendReceiptModalContent, { formSubmitted: formSubmitted, name: name, sentTo: sentTo, onGoToDashboard: onGoToDashboard, onRequestClose: onRequestClose, email: email, phone: phone, handleSendReceipt: handleSendReceipt, alphaeonAccountNumber: alphaeonAccountNumber, daysUntilAuthExpiration: daysUntilAuthExpiration, receiptType: receiptUrl ? 'contract' : 'receipt', optedOutOfSms: optedOutOfSms }) }) }));
};
exports.default = SendReceiptModal;
